import { Component, OnInit, ViewChild, OnDestroy, Input } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { CpmService } from '../../../service/cpm.service'
import { StoreService } from '../../../service/store.service'
import { Subscription } from 'rxjs/Subscription'
import { DataTableDirective } from 'angular-datatables'
import { Subject } from 'rxjs/Subject'
@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class SummaryComponent implements OnInit, OnDestroy {
  @ViewChild(DataTableDirective) dtElement: DataTableDirective
  @Input() isFullFactSheet
  dtTriggerForCoporateSummary: Subject<any> = new Subject()
  subscription: Subscription
  corporateSummary: DataTables.Settings = {}
  listTable = []
  header
  textSummary
  listShowTableValue = []
  listShowFlag = []
  listShowValue = []
  listShowForExcel = []
  listHeader = []
  listShowTableFlag = []
  listHeaderFlag = []
  listHeaderValue = []
  initTableFirstTime = false
  symbol
  securitySymbol
  round = 5
  headerExcel
  excelSummary = []

  drawReadyFlag: Boolean = false

  constructor(
    private store: StoreService,
    private cpmService: CpmService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    const { symbol } = this.activatedRoute.snapshot.params
    this.checkTextSummary()
    if (symbol !== undefined) {
      this.securitySymbol = symbol
      this.onChangeData()
    } else {
      this.subscription = this.store
        .getSecurityProfileNewResultObservable()
        .subscribe(response => {
          if (!response) {
            return
          }
          this.securitySymbol = response['securitySymbol']
          this.onChangeData()
        })
    }
    this.header = []
    this.listTable = []
    this.corporateSummary = {
      autoWidth: false,
      paging: false,
      searching: false,
      info: false,
      orderFixed: [6, 'asc'],
      order: [7, 'asc'],
      columnDefs: [
        { targets: 6, visible: false },
        { targets: 7, visible: false }
      ],
      drawCallback: function(settings) {
        const api = this.api()
        const rows = api.rows({ page: 'current' }).nodes()
        let last = null
        api
          .column(6, { page: 'current' })
          .data()
          .each(function(group, i) {
            if (last !== group) {
              $(rows)
                .eq(i)
                .before(
                  '<tr class="group"><td colspan="6" style="font-weight:bold;background-color:rgb(214, 214, 218)">' +
                    group +
                    '</td></tr>'
                )
              last = group
            }
          })
      }
    }
  }
  onChangeData() {
    this.drawReadyFlag = false
    const secSymbol = this.securitySymbol
    if (this.initTableFirstTime) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy()
      })
    }
    this.cpmService.getSummaryCorporateAction(secSymbol, this.round).then(
      summary => {
        this.listTable = summary
        this.listShowFlag = []
        this.listShowValue = []
        this.listHeaderValue = []
        this.listHeaderFlag = []
        this.listHeader = []
        this.header = []
        this.listTable.map(obj => {
          if (obj.type === 'Cash') {
            obj.data.map(data => {
              this.listHeaderValue.push(data.caType)
              data.data.map(vl => {
                const lsvalue = {
                  head: data.caType,
                  year: vl.year,
                  value: vl.value
                }
                this.listShowValue.push(lsvalue)
              })
            })
          } else if (obj.type === 'Non-cash') {
            obj.data.map(data => {
              this.listHeaderFlag.push(data.caType)
              data.data.map(fl => {
                const lsflag = {
                  head: data.caType,
                  year: fl.year,
                  flag: fl.flag
                }
                this.listShowFlag.push(lsflag)
              })
            })
          }

          this.listHeader = this.listHeader.reduce(function(a, b) {
            if (a.indexOf(b) < 0) {
              a.push(b)
            }
            return a
          }, [])

          this.header = this.header.reduce(function(a, b) {
            if (a.indexOf(b) < 0) {
              a.push(b)
            }
            return a
          }, [])
        })
        this.listShowTableValue = []
        this.listShowForExcel = []
        this.listShowTableFlag = []
        const year = new Date().getFullYear()
        for (let i = year - 4; i <= year; i++) {
          this.header.push(i)
        }
        this.listHeaderValue.map(headerV => {
          const listValue = []
          const listValueforExcel = []
          this.header.map(head => {
            let tmpValue = '-'
            let tmpValueForExcel = null
            this.listShowValue.map(lsV => {
              if (lsV.year === head && lsV.head === headerV) {
                tmpValue = Number(
                  parseFloat(lsV.value).toFixed(0)
                ).toLocaleString('en')
                tmpValueForExcel = lsV.value
              }
            })
            listValue.push(tmpValue)
            listValueforExcel.push(tmpValueForExcel)
          })
          listValue.unshift(headerV)
          listValueforExcel.unshift(headerV)
          this.listShowTableValue.push(listValue)
          this.listShowForExcel.push(listValueforExcel)
          // console.log(this.listShowForExcel, '-- this.listShowForExcel')
        })
        this.listHeaderFlag.map(headerF => {
          const listFlag = []
          this.header.map(head => {
            let tmpValue = 'No'
            this.listShowFlag.map(lsF => {
              if (lsF.year === head && lsF.head === headerF) {
                lsF.flag === 'Y' ? (tmpValue = 'Yes') : (tmpValue = 'No')
              }
            })
            listFlag.push(tmpValue)
          })
          listFlag.unshift(headerF)
          this.listShowTableFlag.push(listFlag)
        })
        this.header.unshift('Fin instrument')
        this.headerExcel = [...this.header]
        this.header.push('Header', 'Def')
        // this.ws_data_toExcel()
        this.drawReadyFlag = true
        if (!this.initTableFirstTime) {
          this.dtTriggerForCoporateSummary.next()
          this.initTableFirstTime = true
        } else {
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            this.dtTriggerForCoporateSummary.next()
          })
        }
      },
      err => {}
    )
  }
  noSummaryData() {
    let flagNoData = true
    this.listTable.map(obj => {
      if (obj.data.length > 0) {
        flagNoData = false
      }
    })
    return flagNoData
  }
  noSummaryNonCashData() {
    return this.listShowFlag.length > 0 ? false : true
  }
  ngOnDestroy() {
    this.subscription.unsubscribe()
  }
  checkYesNoData(text) {
    if (text === 'Yes' || text === 'No') {
      return true
    } else {
      return false
    }
  }
  checkTextSummary() {
    return this.isFullFactSheet === true
      ? (this.textSummary = 'Corporate action summary')
      : (this.textSummary = 'Summary')
  }

  get ws_data_toExcel() {
    const ws_data = [];
    ws_data.push(['Summary'])
    ws_data.push(this.headerExcel)
    ws_data.push(['Cash (Baht)'])
    this.listShowForExcel.map(value => {
      ws_data.push(value)
    })
    ws_data.push(['Non cash'])
    this.listShowTableFlag.map(flag => {
      ws_data.push(flag)
    })

    return ws_data
  }

}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/corporate-action/summary/summary.component.ts